<footer class="sg-mega-footer sg-pt-1 sg-pt-md-2" *ngIf="data">
    <section class="container">
        <section class="row">
            <div class="col-12 col-md-6">
                <section class="row">
                    <div class="col-12 col-sm-6 mb-4">
                        <div class="mx-3 mx-md-0 mt-md-3" *ngIf="data.links1">
                            <h3 class="sg-heading__h4 text-uppercase mb-2">{{ data.links1.title }}</h3>
                            <p class="sg-subheading__h4 mb-2 min-paragraph-fix">{{ data.links1.description }}</p>
                            <hr class="sg-divider mt-0" />
                            <a [href]="link.href" *ngFor="let link of data.links1.links" (click)="clearCityCookie(link.href)" class="py-2 py-lg-0">{{ link.name }}</a>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 mb-4">
                        <div class="mx-3 mx-md-0 mt-md-3">
                            <h3 class="sg-heading__h4 text-uppercase mb-2">{{ data.links2.title }}</h3>
                            <p class="sg-subheading__h4 mb-2 min-paragraph-fix">{{ (sports) ? data.links2.sports.description : data.links2.city.description }} {{ (sports) ? cityUppercase : '' }}</p>
                            <hr class="sg-divider mt-0" />
                            <div class="row">
                                <ng-container *ngIf="sports && sports.data && sports.data.length">
                                    <a [href]="city + '/' + sport.id" *ngFor="let sport of sports?.data" class="col-6 py-2 py-lg-0">{{ sport.attributes.name }}</a>
                                </ng-container>

                                <ng-container *ngIf="!sports">
                                    <a [href]="cityData.attributes.slug" *ngFor="let cityData of cities?.data" class="col-12 py-2 py-lg-0">{{ cityData.attributes.name }}</a>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <div class="col-12 col-md-6 mb-4">
                <div class="sg-mega-footer__container" *ngIf="data.links3">
                    <h3 class="sg-heading__h4 text-uppercase mb-2">{{ data.links3.title }}</h3>

                    <a [href]="data.links3.links[0].href">{{ data.links3.links[0].name }}</a>
                    <p class="sg-subheading__h4 mb-2">{{ data.links3.links[0].description }}</p>

                    <a [href]="data.links3.links[0].href">{{ data.links3.links[1].name }}</a>
                    <p class="sg-subheading__h4 mb-2">{{ data.links3.links[1].description }}</p>

                    <!-- <div class="row">
                        <div class="col-12 col-sm-6">
                            <a [href]="data.links3.links[1].href">{{ data.links3.links[1].name }}</a>
                            <p class="sg-subheading__h4 mb-2">{{ data.links3.links[1].description }}</p>
                        </div>

                        <div class="col-12 col-sm-6">
                            <a [href]="data.links3.links[2].href">{{ data.links3.links[2].name }}</a>
                            <p class="sg-subheading__h4 mb-2">{{ data.links3.links[2].description }}</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </section>

        <section class="row">
            <div class="col-12 col-md-6">
                <section class="row">
                    <div class="col-12 col-sm-6 mb-4">
                        <div class="mx-3 mx-md-0" *ngIf="data.links4">
                            <h3 class="sg-heading__h4 text-uppercase mb-2">{{ data.links4.title }}</h3>
                            <p class="sg-subheading__h4 mb-2 min-paragraph-fix">{{ data.links4.description }}</p>
                            <hr class="sg-divider mt-0" />
                            <a [href]="link.href" *ngFor="let link of data.links4.links" class="py-2 py-lg-0">{{ link.name }}</a>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6 mb-4">
                        <div class="mx-3 mx-md-0">
                            <h3 class="sg-heading__h4 text-uppercase mb-2">{{ data.links5.title }}</h3>
                            <p class="sg-subheading__h4 mb-2 min-paragraph-fix">{{ data.links5.description }}</p>
                            <hr class="sg-divider mt-0" />
                            <a [href]="link.href" *ngFor="let link of data.links5.links" class="py-2 py-lg-0">{{ link.name }}</a>
                        </div>
                    </div>
                </section>
            </div>

            <div class="col-12 col-md-6 mb-4">
                <div class="mx-3 mx-md-0">
                    <div class="row">
                        <div class="col-12 col-sm-6 mb-4">
                            <h3 class="sg-heading__h4 text-uppercase mb-4">
                                <mlp-ng-icon name="lock-1" class="pt-1"></mlp-ng-icon> Secure Payments
                            </h3>

                            <p class="sg-subheading__h4 mb-2">All payments are processed securely through Stripe</p>

                            <ng-container *ngFor="let icon of data.payments">
                                <mlp-ng-icon [name]="icon" size="medium"></mlp-ng-icon>&nbsp;
                            </ng-container>
                        </div>

                        <div class="col-12 col-sm-6">
                            <h3 class="sg-heading__h4 text-uppercase mb-4">{{ data.app.title }}</h3>

                            <a [href]="image.href" class="mb-1 py-2 py-lg-0" target="_blank" *ngFor="let image of data.app.images">
                                <img [attr.alt]="image.name" [attr.data-src]="image.src" width="150" class="mb-1 lazyload" loading="lazy">
                            </a>

                            <div class="d-block d-md-none sg-mb-1">
                                <img [attr.alt]="data.gdprLogo.alt" [attr.data-src]="data.gdprLogo.src" [width]="data.gdprLogo?.width" class="lazyload" loading="lazy">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="row">
            <div class="col-12 col-md-6 mb-4 text-center text-md-left d-flex flex-column gdpr-section">
                <div class="flex-grow-1"></div>

                <div class="sg-mb-1 d-none d-md-block">
                    <img [attr.alt]="data.gdprLogo.alt" [attr.data-src]="data.gdprLogo.src" [width]="data.gdprLogo?.width" class="mb-1 lazyload" loading="lazy">
                </div>

                <div class="mb-md-0 py-2 py-lg-0">
                    <img [src]="data.logoPin" [attr.alt]="data.logoPinAlt" class="logo-pin" loading="lazy">
                    {{ data.somewhere }} &copy; All Rights Reserved {{ currentYear }}
                </div>
            </div>

            <div class="col-12 col-md-6 text-center text-md-right">
                <a href="https://www.bookteq.com/">
                    <img alt="Bookteq is a certified B Corp" [attr.data-src]="data.bcorpLogo" class="lazyload mr-4" loading="lazy" width="90" >
                    <img alt="Bookteq Powered by Playfinder" width="200" [attr.data-src]="data.logo" class="lazyload" loading="lazy">
                </a>
            </div>
        </section>
    </section>
</footer>
